import { render, staticRenderFns } from "./p1s3UserManagement.vue?vue&type=template&id=45c638a0&scoped=true"
import script from "./p1s3UserManagement.vue?vue&type=script&lang=js"
export * from "./p1s3UserManagement.vue?vue&type=script&lang=js"
import style0 from "./p1s3UserManagement.vue?vue&type=style&index=0&id=45c638a0&prod&scoped=true&lang=css"
import style1 from "./p1s3UserManagement.vue?vue&type=style&index=1&id=45c638a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c638a0",
  null
  
)

export default component.exports